<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/136nRE6/images/Cover.jpg?1705026943159" alt="This image is the cover for the book Disinherited Generations"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Disinherited Generations
      </h1>
      <p class="bookDescription body article font2">
        <b>Two Cree women tell the story of how they took on the Canadian government and helped change the lives of thousands.</b><br/><br/> This oral autobiography of two remarkable Cree women tells their life stories against a backdrop of government discrimination, First Nations activism, and the resurgence of First Nations communities.<br/><br/> Nellie Carlson and Kathleen Steinhauer, who helped to organize the Indian Rights for Indian Women movement in western Canada in the 1960s, fought the Canadian government’s interpretation of treaty and Aboriginal rights, the Indian Act, and the male power structure in their own communities in pursuit of equal rights for Aboriginal women and children. After decades of activism and court battles, First Nations women succeeded in changing these oppressive regulations, thus benefitting thousands of their descendants. Those interested in human rights, activism, history, and Native Studies will find that these personal stories, enriched by detailed notes and photographs, form a passionate record of an important, continuing struggle.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nellie Carlson, Kathleen Steinhauer
      </h2>
      
      <p class="authorDescription body article">Nellie Carlson (1927-2020) was born into the Saddle Lake Cree Nation and was a founder and long-time activist with Indian Rights for Indian Women. She lived in Edmonton. Kathleen Steinhauer (1932-2012) was born into the Saddle Lake Cree Nation and was a founder and long-time activist with Indian Rights for Indian Women. She lived in Edmonton. Linda Goyette is a writer, editor, and award-winning journalist. After working for Canadian daily newspapers for twenty years, she published seven books on oral history, contemporary storytelling, and human rights. She divides her time between Alberta and Ontario. Maria Campbell is a Métis author, playwright, broadcaster, filmmaker, and Elder.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Alberta Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7fa74129